import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import { getsFoldersByIdsRpc } from 'framework-listing-lib/__generated__/chirp/com/hubspot/framework/folders/rpc/FoldersRpc';
import { chirpCrmObjectPropertyVersionsBackport } from 'framework-listing-lib/internal/adapters/properties';
import { rpcClient } from 'framework-listing-lib/internal/api/client';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
const GET_FOLDERS_BY_ID_FIELD_NAME = 'getFoldersById';
const GET_FOLDERS_BY_ID = registerQuery({
  args: ['folderIds', 'objectTypeId'],
  fieldName: GET_FOLDERS_BY_ID_FIELD_NAME,
  fetcher({
    folderIds,
    objectTypeId
  }) {
    return rpcClient.call(getsFoldersByIdsRpc, {
      request: {
        enabledObjectTypeId: objectTypeId,
        folderIds
      }
    }).then(response => response.results.map(chirpCrmObjectPropertyVersionsBackport));
  }
});
export default function useFetchFoldersById(folderIds) {
  const objectTypeId = useObjectTypeId();
  const _useQuery = useQuery(GET_FOLDERS_BY_ID, {
      fetchPolicy: 'no-cache',
      variables: {
        folderIds,
        objectTypeId
      },
      skip: folderIds.length === 0
    }),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return useMemo(() => {
    return Object.assign({
      data: data && GET_FOLDERS_BY_ID_FIELD_NAME in data && Array.isArray(data[GET_FOLDERS_BY_ID_FIELD_NAME]) ? data[GET_FOLDERS_BY_ID_FIELD_NAME] : []
    }, rest);
  }, [data, rest]);
}